<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <header class="sticky top-0 z-20 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
    <div class="flex items-center justify-between h-16 px-4 lg:px-6">
      <!-- Left Section: Toggle Button (when collapsed) & Page Title -->
      <div class="flex items-center gap-3">
        <!-- Persistent Sidebar Toggle when collapsed -->
        <button
          v-if="showSidebar && !isOpen"
          @click="toggleSidebar"
          type="button"
          data-testid="sidebar-expand-btn"
          class="p-1.5 rounded-lg hover:bg-blue-50 dark:hover:bg-gray-700 text-[#227BE2] transition-colors inline-flex items-center justify-center"
          title="Expand Sidebar"
          aria-label="Expand Sidebar"
        >
          <span class="w-5 h-5 inline-flex items-center justify-center [&>svg]:w-full [&>svg]:h-full [&>svg]:block" v-html="arrowSvg"></span>
        </button>

        <h1 class="text-xl font-bold text-gray-900 dark:text-white">{{ pageTitle }}</h1>
      </div>

      <!-- Right Section: Notification Bell -->
      <div class="flex items-center">
        <button
          type="button"
          class="p-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          title="Notifications"
          aria-label="Notifications"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useSidebar } from '@/composables/useSidebar'
import { useAuthStore } from '@/stores/auth'
import arrowSvg from '@/assets/images/sidebar/arrow.svg?raw'

const route = useRoute()
const { isOpen, toggleSidebar } = useSidebar()
const authStore = useAuthStore()

const pageTitle = computed(() => route.meta?.title || 'Dashboard')

const showSidebar = computed(() => {
  if (authStore.isAdmin) return true
  const allowedItems = authStore.allowedSidebarItems
  if (allowedItems === null) return true
  return allowedItems.length > 0
})
</script>
